var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIccCrictosLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 224,
    viewBox: "0 0 226 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1172:2957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2426 143.815C35.2426 143.815 42.1631 166.477 65.303 186.329C65.303 186.329 94.0197 129.082 165.223 130.089C165.223 130.089 108.467 94.2713 35.2426 143.815Z",
    fill: "#3C5CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2426 143.815C35.2426 143.815 42.1631 166.477 65.303 186.329C65.303 186.329 94.0197 129.082 165.223 130.089C165.223 130.089 108.467 94.2713 35.2426 143.815Z",
    fill: "url(#paint0_linear_1172:2957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.246 45.9167C203.776 37.2052 196.57 29.5603 188.27 23.5156C164.952 6.5191 134.368 -1.48133 105.639 0.22543C81.584 1.65958 58.3609 10.8927 39.9299 26.3838C21.7843 41.6617 8.71609 62.5932 3.13922 85.6225C1.04641 94.2511 0 103.129 0 112.018C0 173.864 50.2988 224 112.346 224C112.524 224 110.562 222.341 110.348 222.175C106.246 219.176 102.06 216.284 97.9817 213.238C91.4773 208.391 85.1513 203.318 79.075 197.948C71.9048 191.596 65.0793 184.84 58.9079 177.503C52.6176 170.036 46.9575 161.952 42.7362 153.122C39.704 146.781 37.7539 140.251 36.4577 133.364C35.0665 125.945 35.7205 118.063 37.6231 110.43C39.5375 102.761 42.7124 95.3534 46.351 88.9412C65.0556 55.9321 108.006 37.8689 144.297 45.3123L124.546 60.6375C180.481 46.9835 226 99.3951 226 99.3951C226 83.8209 220.364 68.6142 213.966 54.6283C212.587 51.6415 211.005 48.7258 209.246 45.9167Z",
    fill: "#3C5CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.246 45.9167C203.776 37.2052 196.57 29.5603 188.27 23.5156C164.952 6.5191 134.368 -1.48133 105.639 0.22543C81.584 1.65958 58.3609 10.8927 39.9299 26.3838C21.7843 41.6617 8.71609 62.5932 3.13922 85.6225C1.04641 94.2511 0 103.129 0 112.018C0 173.864 50.2988 224 112.346 224C112.524 224 110.562 222.341 110.348 222.175C106.246 219.176 102.06 216.284 97.9817 213.238C91.4773 208.391 85.1513 203.318 79.075 197.948C71.9048 191.596 65.0793 184.84 58.9079 177.503C52.6176 170.036 46.9575 161.952 42.7362 153.122C39.704 146.781 37.7539 140.251 36.4577 133.364C35.0665 125.945 35.7205 118.063 37.6231 110.43C39.5375 102.761 42.7124 95.3534 46.351 88.9412C65.0556 55.9321 108.006 37.8689 144.297 45.3123L124.546 60.6375C180.481 46.9835 226 99.3951 226 99.3951C226 83.8209 220.364 68.6142 213.966 54.6283C212.587 51.6415 211.005 48.7258 209.246 45.9167Z",
    fill: "url(#paint1_linear_1172:2957)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1172:2957",
    x1: 159.717,
    y1: 189.054,
    x2: 71.1811,
    y2: 35.2072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C5DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4086,
    stopColor: "#3352E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223EC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1172:2957",
    x1: 159.717,
    y1: 189.054,
    x2: 71.1811,
    y2: 35.2072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C5DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4086,
    stopColor: "#3352E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223EC5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1172:2957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226,
    height: 224,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIccCrictosLogo);
export default __webpack_public_path__ + "static/media/icc_crictos_logo.9143f6954f4441a730ec8c1ccbee5fcb.svg";
export { ForwardRef as ReactComponent };